<template>
  <div class="input tel-input__wrap" :class="{_white:white, _error: error}">
    <div v-if="label" class="input__label">
      <span>{{ label }}
        <span v-if="isAttributeTrue($attrs.required)"
              class="input__required"> *</span>
      </span>
    </div>

    <vue-tel-input ref="telInput"
                   v-on="bindedListeners"
                   v-bind="$attrs"
                   :value="valueComputed"
                   :preferred-countries="phoneOptions.preferredCountries"
                   disabled-fetching-country
                   @open="onOpen"
                   @close="onClose"
                   :class="{_white:white, _open: isOpen}"
                   class="phone-input"
                   @validate="onValidate"
                   @country-changed="onCountryChanged"
    />

    <InputError :value="error"/>
  </div>
</template>

<script>
  import { VueTelInput } from 'vue-tel-input';
  import InputError from './BaseInputError'

  export default {
    inheritAttrs: false,
    components: {
      InputError,
    },
    props: {
      white: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      error: {
        type: [String, Array]
      },
      value: {
        type: [String, Number]
      }
    },
    data() {
      return {
        phone: '',
        focus: false,
        isOpen: false,
        phoneOptions: {
          placeholder: ' ',
          required: false,
          enabledCountryCode: false,
          validCharactersOnly: true,
          enabledFlags: true,
          preferredCountries: ['ua', 'pl', 'lt', 'cz'],
          autocomplete: 'off',
          name: 'phone',
          maxLen: 20,
          wrapperClasses: 'input-phone',
          inputClasses: 'input__input',
          dropdownOptions: {
            disabledDialCode: false
          },
          inputOptions: {
            showDialCode: true
          }
        }
      }
    },
    computed: {
      bindedListeners() {
        const listeners = { ...this.$listeners };
        delete listeners.validate;
        return listeners;
      },
      valueComputed() {
        if (this.value && this.value.length > 2 && !this.value.toString().startsWith('+')) {
          return '+' + this.value
        }

        return this.value
      },
      onlyCountriesDialCodes() {
        return globalConfigs?.accepted_country_codes || [];
      },
      onlyCountries() {
        // TODO temporary disabled
        const defaultCountries = VueTelInput.props.allCountries.default();
        const result = [];

        for (const country of defaultCountries) {
          const dialCode = Number(country.dialCode);
          if (!this.onlyCountriesDialCodes.includes(dialCode)) continue;
          result.push(country);
        }
        return result;
      },
      currentLocale() {
        return this.$store.state.currentLocale
      },
      isPassword() {
        return this.$attrs.type === 'password'
      },
      filled() {
        return !!this.value || Number.isFinite(this.value)
      },
      selector() {
        let selector = ''
        if (this.overTitle) selector += ' _over '
        if (this.focus) selector += ' _focus '
        if (this.filled) selector += ' _filled '
        if (this.error) selector += ' _error '
        if (this.isPassword) selector += ' _password '
        return selector
      },
      style() {
        let s = {}

        if (this.leftSpace) {
          s.paddingLeft = (1.7 + this.leftSpace) + 'rem'
        }

        return s
      }
    },
    created() {
      if (!this.phone) {
        this.phone = this.value
      }
    },
    methods: {
      onChange(event) {
        this.$emit('change', event.target.value)
      },
      onFocus() {
        this.focus = true
        this.$emit('focus')
      },
      onBlur() {
        this.focus = false
      },
      onOpen() {
        this.isOpen = true
      },
      onClose() {
        this.isOpen = false
      },
      onValidate() {
        this.$emit('validate', this.getPhoneObject());
      },
      onCountryChanged() {
        this.$emit('validate', this.getPhoneObject());
      },
      getPhoneObject() {
        const { phoneObject, activeCountry } = this.$refs.telInput;
        const valid = phoneObject.valid && phoneObject.regionCode === activeCountry.iso2;
        const isValid = phoneObject.isValid && phoneObject.regionCode === activeCountry.iso2;
        return { ...phoneObject, valid, isValid };
      },

      isAttributeTrue(attr) {
        return attr || attr === ''
      },
    }
  }
</script>

<style lang="less">

</style>
